import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(app)/play-cafe/_components/CafeSection.tsx");
